<div class="media d-flex align-items-center">
    <a  [routerLink]="['/shop/product/left/sidebar', product.title.replace(' ', '-'), product.sku]">
        <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
            [lazyLoad]="ImageSrc ? ImageSrc : product.images[0]" class="img-fluid lazy-loading"
            alt="{{ product.images[0] }}">
    </a>
    <div class="media-body align-self-center" style="display: grid; align-items: center; justify-content: center;">
        <div class="rating">
            <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
        </div>
        <a  [routerLink]="['/shop/product/left/sidebar', product.title.replace(' ', '-'), product.sku]">
            <h6 style="margin-bottom: 15px;">{{ product.title | titlecase }}</h6>
        </a>
        <h3
            style="color: #212529; display: flex; justify-content: left; align-items: baseline; gap: 0.2em; flex-wrap: wrap;">
            <span style="font-size: 17px; font-weight: normal;">Desde</span>
            <span
                style="font-size: 30px; font-weight: bold;">
                ${{ product.tienePromocion ? (product.priceDiscount / 12 | number:'1.2-2') : (product.price / 12) | number:'1.2-2' }}
            </span>

        </h3>
        <span style="color: #212529; margin-bottom: 0px; font-weight: normal; font-size: 17px;">a 12 mensualidades o</span><br>
        <span style="color: #212529; margin-bottom: 0px; font-weight: normal; font-size: 17px;"> desde
            <span style="font-size: 20px; font-weight: bold;">
                ${{ product.tienePromocion ? (product.priceDiscount / 60 | number:'1.2-2') : (product.price / 60) | number:'1.2-2' }}
            </span>
            en pagos quincenales</span><br>
        <del *ngIf="product?.tienePromocion"><span class="money"> {{ product?.price * currency?.price |
                currency:currency?.currency:'symbol' }}</span></del>
        <!-- <h4 style="color: #176ec0; text-transform: none; font-weight: bold;">
            Contado a {{product.priceDiscount |currency:currency?.currency:'symbol' }}
        </h4> -->
        <div class="delivery-txt pt-2" *ngIf="product.envioGratis===true">Envío Gratis</div>
        <ul class="color-variant">
            <li [class]="color" *ngFor="let color of Color(product?.variants)" [ngStyle]="{'background-color': color}"
                (click)="ChangeVariants(color, product)">
            </li>
        </ul>
    </div>
</div>